import { DeviceManager } from  "./DeviceManager";
class LibraryManager {
  constructor() {
    this.developmentMode = true;

    //make this Singleton
    if (LibraryManager.instance) {
      return LibraryManager.instance;
    }



    this.libraryStatus = {};
    this.libraries = [
      {
        name: "JQUERY",
        path: "https://code.jquery.com/jquery-3.6.0.min.js",
      },
      {
        name: "PDF",
        path: "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.min.js",
      },
      {
        name: "PDFJS",
        path: "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js",
      },
      {
        name: "DASH",
        path: "https://cdn.dashjs.org/latest/dash.all.min.js",
      },
    ];
    if (this.isSamsung()) {
      this.handleSamsung();
    }
    if (this.isWebOS()) {
      this.handleWebOS();
    }
    this.loadLibrary();
  }

  isSamsung() {
    window.deviceManager = new DeviceManager();
    window.deviceManager.isSamsung();
  }

  isWebOS() {
    window.deviceManager = new DeviceManager();
    return window.deviceManager.isLG();
  }

  handleSamsung() {
    let webAPIObj = {
      name: "WEB_API",
      path: "$WEBAPIS/webapis/webapis.js",
    };
    this.libraries.push(webAPIObj);
  }

  handleWebOS() {
    let debugMode = false;
    let webOSObj = {};
    if (debugMode) {
      webOSObj = {
        name: "WEBOS",
        path: "webOSTVjs-1.2.10/webOSTV-dev.js",
      };
    } else {
      webOSObj = {
        name: "WEBOS",
        path: "webOSTVjs-1.2.10/webOSTV.js",
      };
    }
    this.libraries.push(webOSObj);
  }

  onScriptLoad(name, status) {
    this.libraryStatus[name] = status;
  }

  loadLibrary() {
    for (let i = 0; i < this.libraries.length; i++) {
      let path = this.libraries[i].path;
      this.loadEachScript(
        path,
        this.onScriptLoad.bind(this, this.libraries[i].name),
      );
    }
  }

  loadEachScript(scriptPath, callback) {
    try {
      let script = document.createElement("script");
      script.src = scriptPath;
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        if (typeof callback === "function") {
          callback(true);
        }
      };
      script.onerror = () => {
        if (typeof callback === "function") {
          console.error(`Failed to load ${scriptPath}`);
          callback(false);
        }
      };
    } catch (e) {
      console.error("loadEachScript Erroor :: ", e.message);
    }

  }
}

export { LibraryManager };
